import React from 'react'
import PropTypes from 'prop-types'
import Svg from 'src/Components/shared/Svg'

const MovingTruckSvg = ({ className }) => (
  <Svg
    className={className}
    width='67'
    height='50'
    viewBox='0 0 67 50'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M12 42.6H1V1H40V42.6H25' stroke='#9D97A6' strokeWidth='1.5' />
    <path
      d='M46.5 42.6H42.6001V19.2H54.152L56.9551 26.5304L66.0001 29.1045V42.6H60.5'
      stroke='#9D97A6'
      strokeWidth='1.5'
    />
    <path
      d='M18.4999 36C14.916 36 12 38.916 12 42.5001C12 46.0842 14.916 49 18.4999 49C22.084 49 25 46.0842 25 42.5001C25 38.9158 22.0842 36 18.4999 36Z'
      stroke='#9D97A6'
      strokeWidth='1.5'
    />
    <path
      d='M53.4999 36C49.916 36 47 38.916 47 42.5001C47 46.0842 49.916 49 53.4999 49C57.084 49 60 46.0842 60 42.5001C60 38.9158 57.0842 36 53.4999 36Z'
      stroke='#9D97A6'
      strokeWidth='1.5'
    />
  </Svg>
)

MovingTruckSvg.propTypes = {
  className: PropTypes.string
}

export default MovingTruckSvg
